import styled from "@emotion/styled";
import { MDSSeparator, MDSText } from "@/mds";

export const StyledAccountMenuWrapper = styled.span<{ slot?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledSpinnerWrapper = styled.span<{ slot?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
`;

export const StyledCalendarList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[2]};
  padding-top: ${({ theme }) => theme.spacing[2]};
`;

export const StyledCalendarItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};
`;

export const StyledCalendarSeparator = styled(MDSSeparator)`
  margin: ${({ theme }) => theme.spacing[2]} 0;
`;

export const StyledLabelText = styled(MDSText)`
  cursor: pointer;
`;
